module.exports = __webpack_public_path__ + "img/dell-logo.079ab726.png";